module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/cleaning-mobile@3x-cfe76961ecb13a86df50ef2f24ce2c3f.jpg";